import React from 'react';
import variables from '@ingka/variables/design-tokens';
import styled from 'styled-components';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import SearchResults from './SearchResults';
import TMarkUp from './TMarkUp';

const SearchLayout = styled.div`
  margin-bottom: 100px;
  ${`@media (min-width: ${variables.breakpointM}) {
      min-width: 60%;
      margin-bottom: 0;
  }`}
`;

const SearchLayoutTitle = styled.h1.attrs({ as: 'h1', className: 'h1' })`
  margin: 16px 0;
  ${`@media (min-width: ${variables.breakpointM}) {
      margin-top: 60px;
      margin-bottom: 12px;
      margin-left: 0;
      margin-left: 0;
  }`}
`;

const SearchLandingPage = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <SearchLayout>
      <SearchLayoutTitle>
        <TMarkUp
          value={t('spareParts.landingPage.outro.somethingMissingInTheList')}
        />
      </SearchLayoutTitle>
      <p>
        {t('spareParts.landingPage.outro.needAdditionalItems')} <br />
        {t('spareParts.landingPage.outro.enterComponentNumber')}
      </p>
      <div style={{ marginBottom: '12px' }}></div>
      <SearchResults />
    </SearchLayout>
  );
};

export default SearchLandingPage;
